import * as React from 'react';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { useMiaDispatch, useMiaSelector } from '../components/hooks';
import { MessageDialog } from '../components/MessageDialog';
import { SpinnerDialog } from '../components/SpinnerDialog';
import { uiActionCreators } from '../ducks/ui';

const InfoCallDialog = React.lazy(() =>
  import(/* webpackChunkName: 'InfoCallDialog' */ '../sales/shared/salesCalls/InfoCallDialog')
);
const PowerAssessmentDialog = React.lazy(() =>
  import(
    /* webpackChunkName: 'PowerAssessmentDialog' */
    '../sales/dealers/detailComponents/PowerAssessment/PowerAssessmentDialog'
  )
);
const SalesCallFormDialog = React.lazy(() =>
  import(/* webpackChunkName: 'SalesCallFormDialog' */ '../sales/shared/salesCalls/SalesCallFormDialog')
);
const LogisticsSidebarItemDropDialog = React.lazy(() =>
  import(/* webpackChunkName: 'LogisticsSidebarItemDropDialog' */ '../logistics/sidebar/LogisticsSidebarItemDropDialog')
);

interface IGlobalDialogsProps {}

let GlobalDialogs: React.FunctionComponent<IGlobalDialogsProps> = () => {
  const {
    showInfoCallDialog,
    showPowerAssessmentDialog,
    showSalesCallDialog,
    showLogisticsSidebarDropItem
  } = useMiaSelector(state => state.ui);
  const closePowerAssessment = useMiaDispatch(() => uiActionCreators.hidePowerAssessmentDialog());

  return (
    <ErrorBoundary>
      <React.Suspense fallback={<SpinnerDialog />}>
        {showPowerAssessmentDialog && (
          <PowerAssessmentDialog accountNum={showPowerAssessmentDialog.accountNum} onClose={closePowerAssessment} />
        )}
        {showSalesCallDialog && (
          <SalesCallFormDialog
            businessEntityId={showSalesCallDialog.businessEntityId}
            salesCallId={showSalesCallDialog.salesCallId}
            salesCallType={showSalesCallDialog.salesCallType}
          />
        )}
        <MessageDialog />
        <SpinnerDialog />
        {showLogisticsSidebarDropItem && <LogisticsSidebarItemDropDialog request={showLogisticsSidebarDropItem} />}
        {showInfoCallDialog && <InfoCallDialog />}
      </React.Suspense>
    </ErrorBoundary>
  );
};

GlobalDialogs = React.memo<IGlobalDialogsProps>(GlobalDialogs);
export { GlobalDialogs };
